import { Box, Typography } from "@mui/material";

// StatTile is a compact number+label cell. Dense on purpose so many fit per row
// without pushing the page into excessive scrolling.
export default function StatTile({ label, value, hint }: { label: string; value: React.ReactNode; hint?: string }) {
    return (
        <Box sx={{ flex: "1 1 auto", minWidth: 96, px: 1.5, py: 1, border: 1, borderColor: "divider", borderRadius: 1 }}>
            <Typography variant="subtitle1" sx={{ lineHeight: 1.2, fontWeight: 600 }}>{value}</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>{label}</Typography>
            {hint && <Typography variant="caption" color="text.disabled" sx={{ display: "block", lineHeight: 1.2 }}>{hint}</Typography>}
        </Box>
    );
}
